import { MenuItem, Select } from "@material-ui/core";
import { memo, useContext } from "react";
import { BoletoContext } from "../../contexts/BoletoContext";
import useBilletController from "../../controllers/BoletoController";

const SelectContract = ({ contracts }) => {
  const { handleChangeContract } = useBilletController();
  const { contractData } = useContext(BoletoContext);

  return (
    <Select
      onChange={handleChangeContract}
      value={contractData ?? ""}
      variant={"outlined"}
      style={{
        color: "white",
        borderColor: "white",
        padding: 0,
      }}
    >
      {contracts.map((info) => (
        <MenuItem key={info.contract.number} value={info}>
          {info.contract.number}
        </MenuItem>
      ))}
    </Select>
  );
};
export default memo(SelectContract);
